// must be imported directly, if imported from @blockchain/connector, api will not run as there is a top level await
import BlockchainError from 'blockchain/BlockchainError.ts';
import { isBaseError } from '#common/errors/index.ts';

const commonSentryConfig = {
  beforeSend(event, hint) {
    // skip handled errors
    const handled = event.exception?.values?.[0]?.mechanism?.handled;
    if (handled === true) return null;

    if (hint?.originalException instanceof BlockchainError) event.extra = { ...event.extra, blockchainError: hint.originalException };
    if (isBaseError(hint?.originalException)) event.extra = { ...event.extra, error: hint.originalException };

    return event;
  },
};

export default commonSentryConfig;
